document.addEventListener("DOMContentLoaded", function () {
  const buttonSec = document.querySelector('.button___sec');
  const popupOverlays = document.querySelectorAll('.popup-overlay, .popup');

  if (buttonSec && popupOverlays.length > 0) {
    buttonSec.addEventListener('click', function (e) {
      e.preventDefault();
      popupOverlays.forEach(function(popup) {
        popup.classList.add('show');
      });
    });
  }
});

